import React from 'react';

class ConfigurationDetails extends React.Component {
	constructor(props) {
		super(props)
		this.truck = this.props.truck;
	}
	render() {
		// Create rows for configuration details
		let configurationDetails = [];
		for (let i = 0; i < this.truck.axleCount; ++i) {
			configurationDetails[i] = {
				numTires: this.truck.tireCount[i],
				tireWidth: this.truck.tireWidth[i],
				tireRating: this.truck.tireRating[i],
				steerable: this.truck.steerable[i]
			}
			if (i > 0 && i < this.truck.axleCount) {
				configurationDetails[i].feet = this.truck.feet[i];
				configurationDetails[i].inches = this.truck.inches[i];
			}
		}
		

		return (
			<table className="section">
				<thead>
					<tr>
						<th></th>
						<th>No of Tires</th>
						<th></th>
						<th>Tire Width (in or mm)</th>
						<th>Tire Rating (lbs)</th>
						<th>Steerable</th>
					</tr>
				</thead>
				<tbody>
					{configurationDetails.map(function(value, index) {
						let distanceRender = [];
						if (index > 0 && index < this.truck.axleCount) {
							distanceRender.push(<tr key={index}><td>Distance</td><td></td><td>{value.feet} ft {value.inches} in</td><td></td></tr>);
						}
						return (
							<React.Fragment key={index}>
								{distanceRender}
								<tr key={index}>
									<td>Axle {index + 1}</td>
									<td>{value.numTires}</td>
									<td></td>
									<td>{value.tireWidth}</td>
									<td>{value.tireRating}</td>
									<td>{value.steerable}</td>
								</tr>
							</React.Fragment>
						)
					}, this)}
				</tbody>
			</table>		
		);
	}	
}

export default ConfigurationDetails;


// WEBPACK FOOTER //
// ./src/Minnesota/MNOutput/ConfigurationDetails.js